// Preset locations for the location picker. Real GPS centres; New York City is
// the default, with a few dense, well-covered international spots offered
// alongside it. All demo/mock data (placeholder activities, fake friends, the
// flat mile-plane coordinates) is gone — everything else comes from the API.

export const LOCATIONS = [
  { id: 'timessquare', name: 'New York City',  short: 'NYC',    lat: 40.7580, lon: -73.9855 },
  { id: 'sf',          name: 'San Francisco',  short: 'SF',     lat: 37.7880, lon: -122.4074 },
  { id: 'boston',      name: 'Boston',         short: 'Boston', lat: 42.3554, lon: -71.0655 },
  { id: 'philly',      name: 'Philadelphia',   short: 'Philly', lat: 39.9496, lon: -75.1503 },
  { id: 'chicago',     name: 'Chicago',        short: 'Chicago',lat: 41.8827, lon: -87.6233 },
  { id: 'la',          name: 'Los Angeles',    short: 'LA',     lat: 34.0522, lon: -118.2437 },
  { id: 'miami',       name: 'Miami',          short: 'Miami',  lat: 25.7907, lon: -80.1300 },
  { id: 'austin',      name: 'Austin',         short: 'Austin', lat: 30.2672, lon: -97.7431 },
  { id: 'seattle',     name: 'Seattle',        short: 'Seattle',lat: 47.6097, lon: -122.3331 },
  { id: 'dc',          name: 'Washington DC',  short: 'DC',     lat: 38.8951, lon: -77.0364 },
  { id: 'dublin',      name: 'Dublin',         short: 'Dublin', lat: 53.3498, lon: -6.2603 },
  { id: 'london',      name: 'London',         short: 'London', lat: 51.5074, lon: -0.1278 },
  { id: 'bermuda',     name: 'Bermuda',        short: 'Bermuda',lat: 32.2949, lon: -64.7859 },
];

export const DEFAULT_LOCATION_ID = 'timessquare';
